import { render, staticRenderFns } from "./ScreencastStats.vue?vue&type=template&id=57f16156"
import script from "./ScreencastStats.vue?vue&type=script&lang=ts"
export * from "./ScreencastStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports